var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEmailNotificationsIcon = function SvgEmailNotificationsIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 13,
    fill: "none",
    viewBox: "0 0 19 13"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#1A1818",
    strokeWidth: 2,
    d: "M1 1h17v11H1z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#1A1818",
    strokeWidth: 2,
    d: "m1 1 8.242 5L18 1"
  })));
};
export default SvgEmailNotificationsIcon;